import { render } from "./AppTopBar.vue?vue&type=template&id=1854c467&scoped=true"
import script from "./AppTopBar.vue?vue&type=script&lang=js"
export * from "./AppTopBar.vue?vue&type=script&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=1854c467&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1854c467"

export default script